import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { setupApi } from '@/infrastructure/api/setup'

const app = createApp(App)

app.use(createPinia())
setupApi()
app.use(router)

app.mount('#app')

if (window.Cypress) {
  window.app = app
}
